import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_38_95_4W_15_19',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_38_95_4w_15_19_usd',
			AUD: 'simple_premium_4w_59_99_4w_19_99_aud',
			BRL: 'simple_premium_4w_219_4w_85_99_brl',
			CAD: 'simple_premium_4w_49_99_4w_19_99_cad',
			DKK: 'simple_premium_4w_259_4w_99_99_dkk',
			EUR: 'simple_premium_4w_38_95_4w_15_19_eur',
			GBP: 'simple_premium_4w_38_95_4w_15_19_gbp',
			MXN: 'simple_premium_4w_749_4w_289_mxn',
			NOK: 'simple_premium_4w_389_4w_149_nok',
			SEK: 'simple_premium_4w_369_4w_139_99_sek',
			TRY: 'simple_premium_4w_1519_4w_589_try',
			ARS: 'simple_premium_4w_51890_4w_20290_ars',
			COP: 'simple_premium_4w_157390_4w_61690_cop',
			CLP: 'simple_premium_4w_37690_4w_14790_clp',
		},
		primer: 'prd_BUeOruAJb99s',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 31,
		priceMap: {
			USD: 15.19,
			AUD: 19.99,
			BRL: 85.99,
			CAD: 19.99,
			DKK: 99.99,
			EUR: 15.19,
			GBP: 15.19,
			MXN: 289,
			NOK: 149,
			PLN: 56.99,
			SEK: 139.99,
			TRY: 589,
			ARS: 20290,
			COP: 61690,
			CLP: 14790,
		},
		originalPriceMap: {
			USD: 38.95,
			AUD: 59.99,
			BRL: 219,
			CAD: 49.99,
			DKK: 259,
			EUR: 38.95,
			GBP: 38.95,
			MXN: 749,
			NOK: 389,
			PLN: 139.99,
			SEK: 369,
			TRY: 1519,
			ARS: 51890,
			COP: 157390,
			CLP: 37690,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
			AUD: 59.99,
			BRL: 219,
			CAD: 49.99,
			DKK: 259,
			EUR: 38.95,
			GBP: 38.95,
			MXN: 749,
			NOK: 389,
			PLN: 139.99,
			SEK: 369,
			TRY: 1519,
			ARS: 51890,
			COP: 157390,
			CLP: 37690,
		},
	},
}
